const TEMPLATE_TYPE_ALIASES: Record<string, string> = {
  photo: 'photography',
  photos: 'photography',
  photography: 'photography',
  illustration: 'illustration',
  illustrations: 'illustration',
  infographic: 'infographic',
  infographics: 'infographic',
  icon: 'icon',
  icons: 'icon',
  packshot: 'packshot',
  packshots: 'packshot',
  product: 'product',
  products: 'product',
  mockup: 'mockup',
  mockups: 'mockup',
  'digital-mockup': 'digital-mockup',
};

export function normalizeTemplateType(type?: string | null): string {
  return (type ?? '').trim().toLowerCase().replace(/[_\s]+/g, '-');
}

export function toCanonicalTemplateType(type?: string | null): string {
  const normalized = normalizeTemplateType(type);
  if (!normalized) return '';
  return TEMPLATE_TYPE_ALIASES[normalized] || normalized;
}

export function matchesTemplateType(type: string | null | undefined, allowedTypes: string[]): boolean {
  const canonicalType = toCanonicalTemplateType(type);
  if (!canonicalType) return false;
  return allowedTypes.some((allowedType) => toCanonicalTemplateType(allowedType) === canonicalType);
}
